import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { closeAmendAppointmentModal, closeModal } from 'features/order-tracker/store/actions';
import { useTrackModalLoadAnalytics } from 'features/order-tracker/store/hooks';

import {
  AMEND_APPOINTMENT_MODAL_MESSAGE,
  AMEND_APPOINTMENT_MODAL_TITLE,
  ANALYTICS_APPT_KEEP_EDITING,
  ANALYTICS_APPT_MODAL,
  ANALYTICS_APPT_QUIT,
  KEEP_EDITING_LABEL,
  QUIT_LABEL,
} from './constants';

import styles from './styles.module.scss';

export const AmendAppointmentModal: React.FC = () => {
  const dispatch = useDispatch();
  const quitModalRef = useRef<HTMLDivElement>(null);

  useTrackModalLoadAnalytics(quitModalRef, ANALYTICS_APPT_MODAL);

  const keepEditing = (): void => {
    dispatch(closeModal());
  };

  // function onCloseAppointmentLoad() {
  //   // load the form and store status (true/false) in neb_status
  //   const nebStatus = window.KAMPYLE_ONSITE_SDK.loadForm(MEDALLIA_AMMEND_FORM_ID);
  //   if (nebStatus === true) {
  //     window.KAMPYLE_ONSITE_SDK.showForm(MEDALLIA_AMMEND_FORM_ID);
  //   }
  // }

  const quitAmending = (): void => {
    dispatch(closeModal());
    dispatch(closeAmendAppointmentModal());
    // onCloseAppointmentLoad();
  };

  return (
    <div ref={quitModalRef} className={styles.amendAppointmentModalContent}>
      <h4>{AMEND_APPOINTMENT_MODAL_TITLE}</h4>
      <p>{AMEND_APPOINTMENT_MODAL_MESSAGE}</p>
      <div className={styles.actionButtonsContainer}>
        <button onClick={keepEditing} type="button" data-analytics-link={ANALYTICS_APPT_KEEP_EDITING}>
          {KEEP_EDITING_LABEL}
        </button>
        <button onClick={quitAmending} type="submit" data-analytics-link={ANALYTICS_APPT_QUIT}>
          {QUIT_LABEL}
        </button>
      </div>
    </div>
  );
};
